<template>
  <app-base-main parentTable noPadding class="profit-statistics-ASIN">
    <template #filter-group>
      <app-filter-group @reset="$gjReset"
        @query="$gjNoticeQuery"
        :query-loading="queryBtnLoading">
        <gj-country-server-select v-model="filter.countryMarketValue"></gj-country-server-select>
        <gj-select :options="financeCurrencysOption"
          placeholder="币种"
          v-model="filter.currency"
          :clearable="false">
        </gj-select>
        <gj-select-date-picker :type="filter.date.key === 'DAY' ? 'daterange' : 'monthrange'"
          v-model="filter.date"
          :options="dateTypeList"
          :dateClearable="false"
          :shortcut="filter.date.key === 'DAY'">
        </gj-select-date-picker>
        <gj-select-input v-model="filter.keyword"
          :options="keywordTypeList"
          :width="['120px', '150px']">
        </gj-select-input>
        <template #advancedFilter>
          <gj-charger-select v-model="filter.sellingManagerIds"
            collapse-tags
            placeholder="全部负责人"
            style="width: 150px">
          </gj-charger-select>
          <gj-category-select multiple
            v-model="filter.categoryIds">
          </gj-category-select>
          <gj-brand-select v-model="filter.brandId"
            active>
          </gj-brand-select>
        </template>
        <template #right>
          <view-setting :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-complete="handCompleteView"
            @view-change="handleChangeView">
            <template v-slot:dateRange="{ formData }">
              <gj-select style="width: 130px"
                v-model="formData.dateType"
                :options="DATE_TYPE_OPTIONS"
                :clearable="false"
                @change="() => formData.dateRange = 0">
              </gj-select>
              <gj-select style="margin-left: 8px;width: 130px;"
                v-model="formData.dateRange"
                :options="formData.dateType === 'DAY' ? timeRangeOptions : monthRangeOptions" >
              </gj-select>
            </template>
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button type="primary"
        v-if="$permission('storageCostBatch:recalculate')"
        @click="clickRecalculate"> 重算 </gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group :download="$permission('profitStatistics:export')"
        download-url="/operation/profitStatistics/export"
        :download-params="globalParams"
        table-type="vxe-virtual-tree"
        :sort-gjtable="$refs.gjTable"
        help
        setting
        :task="true"
        @clickTask="reloadTaskNumber"
        :task-tip="taskProgressNumber"
        :table-name="tableName"
        :table-columns="columns">
        <template #task-content>
          <profit-statisrics-task ref="task"></profit-statisrics-task>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-tree-table :list="tableData"
        ref="gjTable"
        adaptParent
        :loading="loading"
        :columns="columns"
        :pagerConfig="pagination"
        :show-summary="isMeaningful(summaryObject)"
        :summary-object="summaryObject"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:image="{row}">
          <gj-image :src="row.imageUrl"></gj-image>
        </template>
        <template v-slot:asin="{ row }">
          <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <template v-slot:marketName="{ row }">
          <div v-if="row.parent">{{ row.country }}</div>
          <div v-else>{{ row.marketName }}</div>
        </template>
        <template v-slot:analysis="{ row }">
          <gj-icon iconfont="iconshuju1" class="analysis-icon" @click.native="handleNavigateAsin(row)"></gj-icon>
        </template>
        <template v-slot:skuName="{ row }">
          <div height="100%">
            <gj-text width="90%">{{ row.skuName| defaultShow}}</gj-text>
          </div>
          <div v-if="!row.skuVOList || row.skuVOList.length == 0">{{row.sku | defaultShow}}</div>
          <gj-popover-panel
            v-else
            :width="'200px'"
            :data="row.skuVOList | skuVOList">
            {{row.sku | defaultShow}}
        </gj-popover-panel>
        </template>
        <template v-slot:variationAsin="{ row }">
          <gj-link v-if="row.variationAsin" :href="row.variationAsinUrl" target="_blank">{{ row.variationAsin }}</gj-link>
          <div v-else>-</div>
        </template>
        <template v-slot:platformCost="{ row }">
          <ProfitPopoverPanel title="平台费"
                            :width="'220px'"
                            :data="buildPlatformCost(row)">
            {{(row.currencySymbol || '')}}{{row.platformCost | defaultShow}}
          </ProfitPopoverPanel>
        </template>

        <template v-slot:sellingManagerNames="{ row }">
          <gj-tooltip :content="row.sellingManagerNames" :textLine="2">{{row.sellingManagerNames | defaultShow}}</gj-tooltip>
        </template>

        <template v-for="item in loop_fields"  v-slot:[item.field]="{row}">
          <div :key="item.field">
            <DataClickView @dataClick="handleClickColumn(row, item.field)" :text="(row[item.field]) | defaultShow(row[item.prefix],item.suffix)"/>
          </div>
        </template>

      </gj-tree-table>
    </template>
  </app-base-main>
</template>

<script>
import { isMeaningfulMixin, queryMixin, selectionMixin,noRepeatQueryMixin } from "@/minxins";
import { convertToFullDate } from "@/utils/date.util.js";
import { financeCurrencysOption } from "@/utils/options";
import { COLUMNS, loop_fields } from "./columns"
import { profitStatisticsPage } from "@/api/statistics"
import {getAllProgressCount, recalculateFinanceAnalysisReport} from "@/api/statistics"
import { DATE_SHORTCUTS } from "@/utils/const";
import profitStatisricsTask from "@/views/modules/statistics/profit-statistics/task/profit-statisrics-task"
import FinanceRecalculate from "@/views/modules/common/finance/finance-recalculate-modal";
import { DATE_TYPE_OPTIONS, timeRangeOptions, monthRangeOptions } from '@/utils/options'
import {isMeaningful} from "@/utils/common";
import viewConfig from './viewConfig/ASIN'
import {convertToDate, convertToMonth} from "@/utils/date.util";
import ProfitPopoverPanel from "./profit-popover-panel.vue";
import DataClickView from '@/views/modules/statistics/common/analysis/goods-analysis/widget/data-click-view';
import OperationAnalysisModalNew from "modules/sale/listing/modal/operation-analysis-modal-new";

let COLUMNSMap = COLUMNS.filter(item => item.includesType.includes('asin'));
import { generatorTrulyDateTime, keywordTypeList, dateTypeList, buildPlatform } from './utils';
export default {
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, noRepeatQueryMixin, buildPlatform],
  name: "profit-statistics-asin",
  components: {profitStatisricsTask, ProfitPopoverPanel, DataClickView},
  mounted() {},
  computed: {
    CACHE_PARAMS () {
      return {
        ...this.filter
      }
    }
  },
  data() {
    return {
      loop_fields,
      isMeaningful,
      keywordTypeList,
      dateTypeList,
      DATE_TYPE_OPTIONS,
      timeRangeOptions,
      monthRangeOptions,
      financeCurrencysOption, // 币种
      taskProgressNumber: null,
      loading: false, // 加载
      groupType: "asin",
      tableName: "profit-statistics-asin",
      summaryObject: {}, // 合计对象
      tableData: [], // 表格数据
      filter: {
        timeStamp:null,
        countryMarketValue: {}, // 店铺国家
        categoryIds: null, //品类
        brandId: null, // 品牌
        sellingManagerIds: null, // 销售负责人
        currency: "", // 币种
        date: { key: 'DAY', value: DATE_SHORTCUTS.yesterday.date }, // 时间搜索
        keyword: {
          key: "asin",
          value: this.$route.query.routeValue||null,
          popover: false
        }, // 关键词搜索
      },
      columns: [
        { id: "picture", title: "图片", field: "imageUrl", slots:{default:'image'}, width: "120px", default: true, disabled: true, fixed: 'left'},
        { id: "ASIN", title: "ASIN", field: "asin", slots:{default:'asin'}, width: "100px", default: true, disabled: true, fixed: 'left', sortable:true},
        { id: "analysis", title: "分析", field: "analysis",slots:{default:'analysis'}, minWidth: "100px", default: true, fixed: 'left'},
        { id: "marketName", title: "店铺/国家", field: "marketName",slots:{default:'marketName'}, minWidth: "120px", default: true, fixed: 'left'},
        { id: "skuName", title: "产品名称/SKU", field: "skuName", slots:{default:'skuName'},minWidth: "150px"},
        { id: "variationAsin", title: "父ASIN", field: "variationAsin", slots:{default:'variationAsin'},minWidth: "100px"},
        { id: "sellingManagerNames", title: "负责人", field: "sellingManagerNames", minWidth: "140px", overflowLine: 1, slots:{ default: 'sellingManagerNames' }},
        { id: "categoryName", title: "品类", field: "categoryName", minWidth: "100px"},
        { id: "brandName", title: "品牌", field: "brandName", minWidth: "100px"},
        ...COLUMNSMap
      ],
      moduleName: 'PROFIT-STATISTICS',
      model: viewConfig,
      cacheOptions: {
        useCache: true,
      }
    };
  },
  filters: {
    skuVOList(val = []) {
      return val.reduce((arr, item) => arr.concat({ label: item.col2, value: item.col1 }), [{label: '产品名称', value: 'SKU', bold: true}])
    }
  },
  activated(){
    // 再次进入已被缓存的此页时
    // 若路由中查询参数timeStamp变化时，则为从其他页面点击跳转至此，重新初始化查询参数
    if(this.$route.query.timeStamp!==this.filter.timeStamp){
      this.$gjQueryInit()
      this.$gjNoticeQuery()
    }
  },
  created() {
    this.sort.prop = ""
    this.reloadTaskNumber()
    this.filter.timeStamp = null
  },
  methods: {
    /**
     * 构造视图参数
     */
    generateViewParams (params) {
      let [ startDateTime = '', endDateTime = '' ] = generatorTrulyDateTime(params.dateType, params.dateRange)
      params.startDateTime = params.dateType === 'DAY' ? convertToDate(startDateTime) : convertToMonth(startDateTime)
      params.endDateTime = params.dateType === 'DAY' ? convertToDate(endDateTime) : convertToMonth(endDateTime)
      return Promise.resolve(params)
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{ countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue,
        date: params.date,
        currency: params.currency,
      };
    },
    // 初始化
    $gjQueryInitParams() {
      this.filter = {
        timeStamp:this.$route.query.timeStamp,
        countryMarketValue: this.$route.query.timeStamp?{
          countryIds:this.$route.query.countryIds.split(','),
          marketIds:this.$route.query.marketIds.split(',')
        }:{}, // 店铺国家
        categoryIds: null, //品类
        brandId: null, // 品牌
        sellingManagerIds: null, // 销售负责人
        currency: "", // 币种
        date: {key: 'DAY', value: DATE_SHORTCUTS.yesterday.date}, // 时间搜索
        keyword: {
          key: "asin",
          value: this.$route.query.timeStamp?this.$route.query.routeValue:null,
          popover: false
        }, // 关键词搜索
      };
      // this.filter.countryMarketValue = {};
      // this.filter.keyword.value = null;
      // this.filter.categoryIds= null;
      // this.filter.brandId= null;
      // this.filter.sellingManagerIds= null;
      // this.filter.currency = "";
      // this.filter.date.key = "DAY";
      // this.filter.keyword.key = "asin";
      // this.filter.date.value = DATE_SHORTCUTS.yesterday.date;
    },
    // 重置
    $gjQueryResetParams() {
      this.filter = {
        timeStamp:this.$route.query.timeStamp,
        countryMarketValue: {}, // 店铺国家
        categoryIds: null, //品类
        brandId: null, // 品牌
        sellingManagerIds: null, // 销售负责人
        currency: "", // 币种
        date: {key: 'DAY', value: DATE_SHORTCUTS.yesterday.date}, // 时间搜索
        keyword: {
          key: "asin",
          value: null,
          popover: false
        }, // 关键词搜索
      };
      // this.filter.countryMarketValue = {};
      // this.filter.keyword.value = null;
      // this.filter.categoryIds= null;
      // this.filter.brandId= null;
      // this.filter.sellingManagerIds= null;
      // this.filter.currency = "";
      // this.filter.date.key = "DAY";
      // this.filter.keyword.key = "asin";
      // this.filter.date.value = DATE_SHORTCUTS.yesterday.date;
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      this.loading = true
      this.queryBtnLoading = true;
      const params = {
        model: {
          groupType: this.groupType,
          countryCodes: this.filter.countryMarketValue.countryIds, // 国家
          marketIds: this.filter.countryMarketValue.marketIds, // 店铺
          currency: this.filter.currency, // 币种
          dateRangType: this.filter.date.key, // 统计日期范围
          startStatisticsDate: null, // 开始时间
          endStatisticsDate: null, // 结束时间
          asin: null, // asin
          variationAsin: null, // variationAsin
          sku: null, // sku
          sellingManagerIds: this.filter.sellingManagerIds, // 负责人
          categoryIds: this.filter.categoryIds, // 品类
          brandId: this.filter.brandId, // 品牌
        },
        ...this.querySort,
        ...this.queryPagination,
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.key == "DAY" && this.filter.date.value) {
        params.model.startStatisticsDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd')
        params.model.endStatisticsDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd')
      }else {
        params.model.startStatisticsDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM')
        params.model.endStatisticsDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM')
      }
      this.globalParams = params;
      this.profitStatisticsPage(params)
    },
    // 跳转asin看板
    handleNavigateAsin (row) {
      const params = {
        asinType: 'child',
        asinCode: row.asin,
        countryData: {
          countryIds: row.country ? [row.country]: [], // 国家
          marketIds: row.marketId ? [row.marketId]: [], // 店铺
        },
        date: {
          type: this.filter.date.key,
          value: []
        }
      }
      if (this.filter.date.key == "DAY" && this.filter.date.value) {
        params.date.value[0] = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd')
        params.date.value[1] = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd')
      }else {
        params.date.value[0] = convertToFullDate(this.filter.date.value[0], 'yyyy-MM')
        params.date.value[1] = convertToFullDate(this.filter.date.value[1], 'yyyy-MM')
      }
      this.$router.push({ path: '/statistics/asin-361-analysis', query: { params: JSON.stringify(params)}})
    },
    // 查询list数据
    async profitStatisticsPage(params) {
      this.loading = true;
      this.queryBtnLoading = true
      try {
        let res = await profitStatisticsPage(params);
        this.pagination = this.getPagination(res);
        this.tableData = (res.records || []).map((v,i)=>{
          if(v.items && v.items.length > 0){
            v.parent = true
          }
          v.index = i+1
          return v
        });
        this.summaryObject = res.statisticRecord;
      } finally {
        this.loading = false;
        this.queryBtnLoading = false;
      }
    },
    clickRecalculate() {
      const _this=this;
      this.$gjCreate(FinanceRecalculate,{
        props: {
          requestPromise: recalculateFinanceAnalysisReport,
          requestProps: {
            startDate: 'startStatisticsDate',
            endDate: 'endStatisticsDate',
            marketIds: 'marketIds'
          },
          maxDayLength: 360,
          days: 13
        },
        on:{
          confirm(){
            _this.reloadTaskNumber();
          }
        }
      })
    },
    reloadTaskNumber() {
      getAllProgressCount().then((data) => {
        if (isMeaningful(data) && !isNaN(data) && Number(data) !== 0) {
          this.taskProgressNumber = data;
        } else {
          this.taskProgressNumber = '';
        }
      });
      if (this.$refs && this.$refs.task) {
        this.$refs.task.$gjReset();
      }
    },
     /**
     * 显示弹窗
     */
    handleClickColumn(row, field){
      let params =  this.globalParams;
      let groupType = this.asinType;
      console.log(row, field, params, groupType)
      this.$gjCreate(OperationAnalysisModalNew,{
        props: {
          params:{
            ...params,
            groupType:'msku',
            date:[params.model.startStatisticsDate,params.model.endStatisticsDate],

            row:row,
            field:field
          }
          
        }
      })


    },

  },
};
</script>

<style lang="scss" scoped>
.profit-statistics-ASIN{
  // width: 100%;
  // height: 100%;
  // .table{
  //   height: calc(100% - 100px);
  // }
  .table-shadow{
    box-shadow: none;
  }
  .date-picker {
    width: 136px;
  }
  .analysis-icon {
    font-size: 21px;
    color: #1F6EEF;
    cursor: pointer;
  }
}
</style>
